/* eslint-disable react/prop-types */
import React, { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';

import {
	Box,
  Button,
  Chip,
  Collapse,
  Dialog,
	DialogActions,
	DialogContent,
  Grid,
  IconButton,
  TableRow,
} from '@material-ui/core';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import PhoneIcon from '@material-ui/icons/Phone';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import ReplayIcon from '@material-ui/icons/Replay';
import BlueButton from '../../customUI/BlueButton';
import { StyledTableCell } from '../../customUI/table/TableStyles';

import CallDetails from '../call-details/CallDetails';

import { storeContext } from '../provider/Provider';

import { formatPhoneNumber } from '../../functions';
import RedButton from '../../customUI/RedButton';

const useStyles = makeStyles(() => ({
  blackLink: {
    textAlign: 'center',
    color: 'black',
    textDecoration: 'none',
    userSelect: 'none',
  },
  squareButton: {
    borderRadius: 4,
  },
  arrowButton: {
    padding: 0,
    marginLeft: 0,
    marginRight: 6,
  },
  opportunities__table: {
		fontSize: '.9rem',
    '& th, & td': {
    	fontSize: '.9rem',
			'& div, & .MuiChip-label': {
					fontSize: '.9rem',
			}
    }
  },
}));

const { REACT_APP_HIDE_SPAM } = process.env;

const CallsTableRow = ({ row, rowNumber, handleCallAudioClick, addZero, currentCallId, setCurrentCall, setCurrentCallNumber, setCurrentCallId, setCurrentDate, setOpenDialog, setOpenSpamDialog, setOpenDeleteDialog }) => {
  const { state } = useContext(storeContext);
	const classes = useStyles();
  const [open, setOpen] = useState(false);  
  const [openDetailDialog, setOpenDetailDialog] = useState(false);
  const history = useHistory()

  const splitCamelCaseToString = (s) => {
    const words = s.split(/(?=[A-Z])/);

    for(let i=1; i < words.length; i = 1+i ) {
        if(words[i-1].length === 1 && words[i].length === 1){
            words[i-1] = words[i-1]+words[i];
            words.splice(i);
        }
    }
    return words.join(' ');
  }

  const handleDetailClick = () => {
    history.push({
        state: { detail: row }
    });
    setOpenDetailDialog(true);
  }

  return (
    <>
      <TableRow key={row.id} className={classes.opportunities__table} style={row.id === currentCallId? {background: "#d9edf7"}: {background: "white"}}>
        <StyledTableCell component="th" scope="row">
            {(rowNumber + 1) + (state.leads.currentPage * state.leads.perPage)}
        </StyledTableCell>
        <StyledTableCell component="th" scope="row">
            {row.details && 
            <IconButton
                aria-label="expand row"
                className={classes.arrowButton}
                onClick={() => {
                setOpen(!open);
                }}
            >
                {open ? (
                <KeyboardArrowUpIcon style={{ fontSize: 27, }} />
                ) : (
                <KeyboardArrowDownIcon style={{ fontSize: 27, }} />
                )}
            </IconButton>}
        </StyledTableCell>
        <StyledTableCell component="th" scope="row">
            {`${new Date(row.called_at).toLocaleString('en-US', { timeZone: 'UTC', year: '2-digit', month: 'short', day: '2-digit' })}`}
        </StyledTableCell>
        <StyledTableCell component="th" scope="row">
            {encodeURIComponent(addZero(new Date(row.called_at).getHours()))}
            <span>:</span>
            {encodeURIComponent(addZero(new Date(row.called_at).getMinutes()))}
            <span>:</span>
            {addZero(new Date(row.called_at).getSeconds())}
        </StyledTableCell>
        <StyledTableCell component="th" scope="row" align="left" style={{ background: 'rgba(214, 255, 212, 0.3)', minWidth: 100}}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <a
                    className={classes.blackLink}
                    href={`tel:${row.caller_number_complete.replace(/[^\\d]/g, '')}`}
                >
                    <PhoneIcon style={{ fontSize: 'small', marginRight: 5 }} />
                    {formatPhoneNumber(row.caller_number_complete)}
                </a>
            </div>
        </StyledTableCell>
        <StyledTableCell align="center" style={{ background: 'rgba(0, 180, 224, 0.1)' }}><Chip style={{ width: "100%"}} label={row.status !== '' ? row.status : "-"} color={row.status === 'answered' ? 'primary' : 'default'} /> </StyledTableCell>
        <StyledTableCell align="center" style={{ background: 'rgba(0, 180, 224, 0.1)' }}><Chip style={{ width: "100%"}} label={row.is_returning_number === false ? "New" : "-"} color={row.is_returning_number === false ? 'primary' : 'default'} /> </StyledTableCell>
        <StyledTableCell align="center" style={{ background: 'rgba(0, 180, 224, 0.1)' }}>
            {new Date(row.duration * 1000).toISOString().substr(11, 8)}
        </StyledTableCell>
        <StyledTableCell align="right" style={{ textAlign: 'center' }}>
            {row.audio ? (
                <PlayCircleOutlineIcon
                    style={{ cursor: 'pointer', color: '#38C0F0' }}
                    onClick={() => {
                      setCurrentCallNumber(row.caller_number_complete)
                      setCurrentDate(row.called_at)
                      setCurrentCallId(row.id)
                      handleCallAudioClick(row.audio)
                    }}
                />
            ) : (
                <p style={{ cursor: 'not-allowed', color: '#999999' }}>N/A</p>
            )}
        </StyledTableCell>
        {state.leads.transcriptEnabled && <StyledTableCell>
            { row.transcription_available ? 
                <Box style={{ width: "100%", color: '#00b4e0', textAlign: 'center', cursor: 'pointer'}} onClick={handleDetailClick}>Details &raquo;</Box> :
                <Box style={{ width: "100%", textAlign: 'center'}} >-</Box>
            }
        </StyledTableCell>}
        <StyledTableCell align="left">{row.source}</StyledTableCell>
        <StyledTableCell style={{ minWidth: 300 }} align="center">
            {!row.is_spam ? ( <BlueButton
              aria-label="convert call to lead"
              onClick={() => {
                  setCurrentCallNumber(row.caller_number_complete);
                  setCurrentCallId(row.id);
                  setOpenDialog(true);
              }}
              style={{
                fontSize: "1rem",
                whiteSpace: 'nowrap',
              }}
            >
                Add Lead
            </BlueButton>) : (
              <RedButton
                style={{
                  fontSize: "1rem",
                  borderRadius: '5px',
                  padding: '2px 10px',
                  width: '120px',
                }}
                onClick={() => {
                  setCurrentCall(row);
                  setCurrentCallNumber(row.caller_number_complete);
                  setCurrentCallId(row.id);
                  setOpenDeleteDialog(true);
                }}
              >
                <DeleteIcon 
                  style={{ fontSize: 'medium', marginRight: 5 }} 
                />
                Delete
              </RedButton>
              )}
            {REACT_APP_HIDE_SPAM === "false" && (row.is_spam ? (
            <RedButton
              style={{
                fontSize: "1rem",
                borderRadius: '5px',
                padding: '2px 10px',
                width: '120px',
              }}
              onClick={() => {
                setCurrentCall(row);
                setCurrentCallNumber(row.caller_number_complete);
                setCurrentCallId(row.id);
                setOpenSpamDialog(true);
              }}
            >
              <ReplayIcon 
                style={{ fontSize: 'medium', marginRight: 5 }} 
              />
              Spam
            </RedButton>):
            (<BlueButton
              aria-label="set spam flag for call"
              style={{
                fontSize: "1rem"
              }}
              onClick={() => {
                setCurrentCall(row);
                setCurrentCallNumber(row.caller_number_complete);
                setCurrentCallId(row.id);
                setOpenSpamDialog(true);
              }}
            >
              Mark Spam
            </BlueButton>))}
        </StyledTableCell>
      </TableRow>
      {row.details && <TableRow>
        <StyledTableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
        <Collapse in={open} timeout="auto" unmountOnExit>
            {Object.entries(row.details).map(([key, value]) => {
            if (typeof value !== 'object') {
                return (
                <React.Fragment key={row.uuid + value}>
                    <Grid container>
                        <Grid item xs={3}>
                            <strong>{splitCamelCaseToString(key)}: </strong>
                        </Grid>
                        <Grid item xs={8}>
                            <span>{value}</span>
                        </Grid>
                    </Grid>
                    </React.Fragment>
                    );
                }
                return <></>;
                })}
            </Collapse>
        </StyledTableCell>
      </TableRow>}
      <Dialog
        open={openDetailDialog}
        maxWidth="xl"
        onClose={() => {
          setOpenDetailDialog(false);
        }}
      >
        <DialogContent style={{ minWidth: '90vw'}}>
          <CallDetails />
        </DialogContent>
        <DialogActions>
        <Box>
            <Button
              onClick={() => { setOpenDetailDialog(false) }}
              style={{ color: '#58595B' }}
            >
              Close
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CallsTableRow;
